import { createSelector } from 'reselect'
import { values, orderBy, groupBy, get, zipObject } from 'lodash'
import { mainCurrency } from './config'

export const fundsByKeys = state => state.fund.funds
export const allAccounts = state => state.fund.accounts
export const historics = state => state.fund.history
export const ticker = state => state.fund.ticker
export const fundsAreLoading = state => state.fund.fundsAreLoading
const dashboardUserid = state => state.dashboard.userId

export const funds = createSelector(fundsByKeys, funds => values(funds))

export const fundsWithValue = createSelector(
  funds,
  mainCurrency,
  ticker,
  dashboardUserid,
  (funds, mainCurrency, ticker, dashboardUserid) =>
    ticker &&
    orderBy(
      funds.filter(f => f._userId === dashboardUserid).map(fund => {
        const mainValue =
          ticker.btc[fund.currency] &&
          ticker.btc[fund.currency].value *
            fund.balance *
            ticker.fiat[mainCurrency].value
        let total = mainValue
        // FOR ETH
        if (fund.tokens) {
          for (var i = 0; i < fund.tokens.length; i++) {
            const token = fund.tokens[i]
            if (ticker.btc[token.tokenInfo.symbol]) {
              const value =
                ticker.btc[token.tokenInfo.symbol].value *
                token.balance *
                ticker.fiat[mainCurrency].value
              token.value = value
              total += value
            }
          }
        }
        return {
          ...fund,
          tokens: orderBy(fund.tokens, ['value'], ['desc']),
          total,
          value: mainValue,
        }
      }),
      ['value'],
      ['desc']
    )
)

export const fundsWithValueMergedByCrypto = createSelector(
  fundsWithValue,
  fundsWithValue => {
    const arrayContainsHash = (array, hash) =>
      array.map(h => h.toLowerCase()).indexOf(hash) > -1
    const merged = groupBy(fundsWithValue, 'currency')
    return orderBy(
      Object.keys(merged).map(c => ({
        currency: c,
        balance: merged[c].reduce((sum, fund) => sum + fund.balance, 0),
        value: merged[c].reduce((sum, fund) => sum + fund.value, 0),
        history: merged[c].reduce(
          (sum, fund) => [
            ...sum,
            ...get(fund, 'history', []).map(h => ({
              ...h,
              // convert from or to to "me" if the hash matches
              from: arrayContainsHash(fund.hashes, h.from) ? 'me' : h.from,
              to: arrayContainsHash(fund.hashes, h.to) ? 'me' : h.to,
            })),
          ],
          []
        ),
      })),
      ['value'],
      ['desc']
    )
  }
)

export const totalbalance = createSelector(fundsWithValue, fundsWithValue =>
  fundsWithValue.reduce((sum, fund) => sum + fund.value, 0)
)

export const cryptoArray = createSelector(ticker, ticker => {
  if (ticker && ticker.btc) {
    return Object.keys(ticker.btc).map(k => ({ code: k, ...ticker.btc[k] }))
  } else {
    return []
  }
})

export const fiatArray = createSelector(ticker, ticker => {
  if (ticker && ticker.fiat) {
    return Object.keys(ticker.fiat).map(k => ({ code: k, ...ticker.fiat[k] }))
  } else {
    return []
  }
})

export const cryptocurrencies = createSelector(ticker, ticker => {
  if (ticker && ticker.btc) {
    const keys = Object.keys(ticker.btc)
    return zipObject(keys, keys.map(d => ticker.btc[d].name))
  } else {
    return {}
  }
})

export const hashFunds = createSelector(funds, funds =>
  funds.filter(w => w.type === 'hash')
)



// WEBPACK FOOTER //
// ./src/selectors/funds.js